import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonLinearProgress } from './LinearProgress.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonLinearProgress({ prefix }));
}
